/** tempexp_14728-full-file */
import React, { FC } from 'react';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { Checkbox } from 'reactApp/ui/DataListItemCommonComponents/Checkbox/Checkbox';
import { Download } from 'reactApp/ui/DataListItemCommonComponents/Download/Download';
import { Publish } from 'reactApp/ui/DataListItemCommonComponents/Publish/Publish';
import { Date } from 'reactApp/ui/DataListItemRow/components/Date/Date';
import { Expires } from 'reactApp/ui/DataListItemRow/components/Expires/Expires';
import { ItemName } from 'reactApp/ui/DataListItemRow/components/ItemName/ItemName';
import { Pic } from 'reactApp/ui/DataListItemRow/components/Pic/Pic';
import { Size } from 'reactApp/ui/DataListItemRow/components/Size/Size';
import { TableColumn } from 'reactApp/ui/DataListItemRow/components/TableColumn/TableColumn';
import { SharedItemProps } from 'reactApp/ui/DataListItemRow/DataListItemRow.types';

interface SharedProps extends SharedItemProps {
    checkboxClassname?: string;
}

export const Shared: FC<SharedProps> = (props) => {
    return (
        <>
            <TableColumn>
                <Checkbox
                    viewType={EViewMode.list}
                    className={props.checkboxClassname}
                    onCheckboxClick={props.onCheckboxClick}
                    isSelected={props.isSelected}
                />
                <Pic
                    isFolder={props.isFolder}
                    thumbUrl={props.thumbUrl}
                    kind={props.kind}
                    isVirus={!!props.isVirus}
                    ext={props.ext || ''}
                    isAutoDelete={props?.isAutoDelete}
                    publicExpires={props.publicExpires}
                    isPublic={props.isPublic}
                />
            </TableColumn>
            <TableColumn width="100%" overflow="hidden">
                <ItemName name={props.name} ext={props.ext || ''} id={props.id} isRenameAvailable={props.renameAvailable} />
            </TableColumn>
            {props.isFolder && Boolean(props.publicExpires) && (
                <TableColumn flexBasis={140} flexShrink={0} justifyContent="flex-end">
                    <Expires expires={props.publicExpires} isAutoDelete={props.isAutoDelete} isShared />
                </TableColumn>
            )}
            {!props.isFolder && (
                <TableColumn flexBasis={140} flexShrink={0} justifyContent="flex-end">
                    <Date date={props.mtime} />
                </TableColumn>
            )}
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                <Size size={props.size} />
            </TableColumn>
            <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                <Publish onClick={props.onPublish} isShared={props.isPublic} viewType={EViewMode.list} />
                <Download
                    onClick={props.onDownload}
                    ext={props.isFolder ? 'zip' : props.ext}
                    size={props.size}
                    id={props.id}
                    storage={props.storage}
                    viewType={EViewMode.list}
                />
            </TableColumn>
        </>
    );
};
